import React, {Fragment, useEffect} from "react";
import {Field, reduxForm} from "redux-form";
import {useDispatch, useSelector} from "react-redux";
import {isEmpty} from "lodash";
import {getCurrentUser} from "_helpers";
import {msgSourceActions, reamazeAuthActions} from "_actions";
import {Box} from "@mui/material";
import {Input, InputSubdomain} from "../../Utilities/Input";
import {modalInnerStyles} from "../../Utilities/basicModalStyles";
import SetupModalFooter from "../../Utilities/SetupModalFooter";

function ReamazeSetupForm({description, buttonLabel, extraInfoLabel, openInNewTab, handleSubmit}){
  const dispatch = useDispatch();
  const reamaze = useSelector(state => state.reamazeAuth);

  const [disabled, setDisabled] = React.useState(true);
  const loading = React.useMemo(() => reamaze.loading && !disabled, [reamaze]);

  useEffect(() => {
		dispatch(msgSourceActions.getMsgSourceLink('reamaze'))
  }, []);

	const placeholders = {
		loginEmail: 'Reamaze Login Email Address',
		subdomain: 'yoursubdomain',
		apiKey: 'API Key',
	}

  const performAction = (value) => {
    setDisabled(isEmpty(value));
  };

  const onSubmit = (props) => {
		const { id } = getCurrentUser();
		const params = {
			apiKey: props.apiKey,
			subdomain: props.subdomain,
			loginEmail: props.loginEmail,
			userId: id
		};
		dispatch(reamazeAuthActions.verifyKey(params))
  };

  return(
    <Fragment>
        <Box sx={modalInnerStyles.container}>
            <Box sx={modalInnerStyles.description}>
                {description}
             </Box>

        <form name="reamazeForm" onSubmit={ handleSubmit(onSubmit) }>
            <Field
                name={'subdomain'}
                component={InputSubdomain}
                endAdornmentDomainValue={'.reamaze.com'}
                label={'Reamaze Subdomain'}
                placeholder={placeholders.subdomain}
                performAction={performAction}
            />

            <Field
                name={'loginEmail'}
                component={Input}
                placeholder={placeholders.loginEmail}
            />

            <Field
                name={'apiKey'}
                component={Input}
                placeholder={placeholders.apiKey}
            />

          <SetupModalFooter
            extraInfoLabel={extraInfoLabel}
            openInNewTab={openInNewTab}
            buttonLabel={buttonLabel}
            disabled={loading || disabled}
            loading={loading}
          />
        </form>
      </Box>
    </Fragment>
  )
}

const formConfig = {
  form: 'reamazeForm',
};

export default reduxForm(formConfig)(ReamazeSetupForm);